import { SVGIconProps } from "@faire/slate/icons/types";
import { ButtonBase } from "@faire/slate/private/button/ButtonBase";
import { ButtonIcon } from "@faire/slate/private/button/ButtonIcon";
import { IButtonWebProps } from "@faire/slate/private/button/types";
import React from "react";

type IProps = Omit<IButtonWebProps, "type"> & {
  /**
   * The icon component to render
   */
  Icon: React.FC<SVGIconProps>;
};

export const FormFieldIconButton: React.FC<IProps> = ({ Icon, ...props }) => (
  <ButtonBase
    className="fs-button--tertiary fs-form-field__icon-btn"
    type="button"
    {...props}
  >
    <div className="fs-form-field__icon-btn-touch-target" />
    <ButtonIcon Icon={Icon} titleAccess="" />
  </ButtonBase>
);
